import {createSlice} from "@reduxjs/toolkit";
import {clearIncidentDetail} from "./incidentDetailSlice";

const initialState = {
  loading: false,
  eventData: []
};

export const incidentDetectionSlice = createSlice({
  name: "incidentDetection",
  initialState,
  reducers: {
    getEvents: (state, action) => {
      state.loading = true;
    },
    getEventsSuccess: (state, action) => {
      const events = action.payload;
      state.loading = false;
      state.eventData = events;
    },
    getEventsFailure: (state, action) => {
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearIncidentDetail, () => initialState)
      .addDefaultCase(() => {});
  }
});

export const {getEvents, getEventsSuccess, getEventsFailure} =
  incidentDetectionSlice.actions;

export default incidentDetectionSlice.reducer;
